export const wealthMountainGraphData = [
  { x: 0, y: 0 },
  { x: 0.01031, y: 0 },
  { x: 0.0136, y: 0 },
  { x: 0.01795, y: 0 },
  { x: 0.02368, y: 0 },
  { x: 0.03125, y: 0 },
  { x: 0.04123, y: 0 },
  { x: 0.05441, y: 0 },
  { x: 0.07179, y: 0 },
  { x: 0.09473, y: 91 },
  { x: 0.125, y: 6031 },
  { x: 0.16494, y: 46968 },
  { x: 0.21764, y: 248825 },
  { x: 0.28717, y: 1220191 },
  { x: 0.37893, y: 4009323 },
  { x: 0.5, y: 9476243 },
  { x: 0.65975, y: 18978565 },
  { x: 0.87055, y: 34125301 },
  { x: 1.1487, y: 59004867 },
  { x: 1.51572, y: 99558442 },
  { x: 2, y: 158894788 },
  { x: 2.63902, y: 253080880 },
  { x: 3.4822, y: 398702698 },
  { x: 4.59479, y: 613609403 },
  { x: 6.06287, y: 870446518 },
  { x: 8, y: 958920024 },
  { x: 10.55606, y: 860190995 },
  { x: 13.92881, y: 728786816 },
  { x: 18.37917, y: 632455503 },
  { x: 24.25147, y: 539785447 },
  { x: 32, y: 454853040 },
  { x: 42.22425, y: 385670995 },
  { x: 55.71524, y: 338652880 },
  { x: 73.51669, y: 288312504 },
  { x: 97.00586, y: 221003355 },
  { x: 128, y: 148874355 },
  { x: 168.89701, y: 89941677 },
  { x: 222.86094, y: 48050648 },
  { x: 294.06678, y: 24310987 },
  { x: 388.02344, y: 12301275 },
  { x: 512, y: 6137537 },
  { x: 675.58805, y: 3132725 },
  { x: 891.44378, y: 1623803 },
  { x: 1176.26712, y: 831921 },
  { x: 1552.09376, y: 519036 },
  { x: 2048, y: 351080 },
  { x: 2702.3522, y: 246597 },
  { x: 3565.77511, y: 149955 },
  { x: 4705.06846, y: 102832 },
  { x: 6208.37506, y: 72545 },
  { x: 8192, y: 51885 },
];
